

<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card card-body card-panel-box border-0">
        <div class="row d-flex justify-content-start">
          <h2 style="font-size: 1.2vw !important;">ریسک</h2>
        </div>
        <div class="table-responsive">
          <center v-show="!all_items.length">
            <p> ریسک  وجود ندارد</p>
          </center>
          <table v-show="all_items.length" class="table table-striped">
            <thead>
            <tr>
              <th>ردیف</th>
              <th> شرح ریسک/فرصت    </th>
              <th>علت وقوع </th>
              <th>پیامد و اثر</th>
              <th>نوع شاخص</th>
              <th>فرصت</th>
              <th>ریسک</th>
            </tr>
            </thead>
            <tbody>
            <tr  v-for="(item,index) in all_items">
              <td scope="row">{{index+1}}</td>
              <td>{{item.title}}</td>
              <td>{{ item.reason }}</td>
              <td>{{ item.consequences }}</td>
              <td>{{ item.type }}</td>
              <td>{{ item.opportunity }}</td>
              <td>{{ item.risk }}</td>


            </tr>

            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999; top: 95%;">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItemForm(item_id)">تایید</button>
      </div>
    </div>
  </div>
  <!-- modal  -->
  <!-- modal -->
  <div dir="rtl" class="modal__error slide-top" v-show="error"
       style="z-index: 999999999999999999999999999999999999999999999; top: 25%;">
    <div>
      <p>   خطا  </p>
      <p @click="error=!error">❌</p>
    </div>
    <div>
      {{errorMessage}}



      <button @click="error=!error">بازگشت</button>
    </div>
  </div>
</template>
<script >
export  default {
  props: ['id_route'],

  data(){

    return{
      title: '',
      reason: '',
      consequences: '',
      opportunity: '',
      risk: '',
      item_id: '',
      all_items: [],
       error: false,
      errorMessage: false,
      deleteModal: false,
      editModal: false,

    }
  },
  methods:{
    deleteModalMethod(id){
      this.item_id=id
      this.deleteModal=true
    },
    deleteItemForm(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();



      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/risk_process/destroy/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
            this.showItem()
            this.deleteModal=false


          })
          .catch();
    },
    edit(id){
      this.item_id=id
      this.editModal=true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();



      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/risk_process/edit/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
            const item = response.item
            if (item){
              this.title=item.title
              this.reason=item.reason
              this.consequences=item.consequences
              this.type=item.type
              this.opportunity=item.opportunity
              this.risk=item.risk

            }




          })
          .catch();
    },
    update(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();

      formdata.append('processes_id', this.id_route)
      formdata.append('title', this.title)
      formdata.append('reason', this.reason)
      formdata.append('consequences', this.consequences)
      formdata.append('type', this.type)
      formdata.append('opportunity', this.opportunity)
      formdata.append('risk', this.risk)


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/risk_process/update/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
            this.showItem()

            this.processes_id=''
            this.title=''
            this.reason=''
            this.consequences=''
            this.type=''
            this.opportunity=''
            this.risk=''

            this.editModal=false



          })
          .catch();
    },
    saveItem() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();
      formdata.append('processes_id', this.id_route)
      formdata.append('title', this.title)
      formdata.append('reason', this.reason)
      formdata.append('consequences', this.consequences)
      formdata.append('type', this.type)
      formdata.append('opportunity', this.opportunity)
      formdata.append('risk', this.risk)


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/risk_process/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
            this.showItem()
            this.processes_id=''
            this.title=''
            this.reason=''
            this.consequences=''
            this.type=''
            this.opportunity=''
            this.risk=''

          })
          .catch();

    },
    showItem() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/risk_process/all/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.all){
              this.all_items.length=0
              response.all.forEach((item)=>{
                this.all_items.push(item)
              })

            }


          })
          .catch();

    },

  },
  mounted() {
    this.showItem()

  }
}
</script>

<style scoped>
.table-striped > tbody > tr:nth-of-type(odd) {
  --bs-table-accent-bg: #D0E9FA57;
  color: var(--bs-table-striped-color);
}
</style>